module.exports = __webpack_public_path__ + "img/interactive-window.f0fc0aa9.png";